// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

var originalBuildUrl = BCSfFilter.prototype.buildProductItemUrl;
BCSfFilter.prototype.buildProductItemUrl = function(productData) {
    var originalUrl = originalBuildUrl.call(this, productData);
    
    if (originalUrl.includes('/collections//products/')) {
        originalUrl = originalUrl.replace('/collections//products/', '/collections/all/products/');
    }
    
    return originalUrl;
};
// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};